import React from "react";
function HeroSection() {
  return <section className="section-card" data-id="element-81">
      <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-82">
        {/* Left side – text content */}
        <div className="space-y-6" data-id="element-83">
          <h1 className="text-3xl md:text-5xl font-bold leading-tight text-white" data-id="element-84">
            ¿Y si en solo 30 días volvieras a sentir a Dios como la primera vez?
          </h1>

          <p className="text-base md:text-lg text-slate-100/80" data-id="element-85">
            No perdiste la fe. Solo te perdiste entre el ruido. Esta guía
            espiritual te lleva paso a paso a reconectar con tu paz interior, a
            escuchar nuevamente a Dios y a sentir tu fe como antes… o más fuerte
            que nunca.
          </p>

          {/* ✅ BOTÓN QUE SUBE A PRICING */}
          <a href="#pricing" className="inline-flex bg-gradient-to-r from-amber-400 to-amber-300 text-slate-900 font-semibold px-8 py-3 rounded-full shadow-lg hover:shadow-xl hover:translate-y-0.5 transition" data-id="element-86">
            QUIERO EMPEZAR MI DÍA 1
          </a>
        </div>

        {/* Right side – VSL video */}
        <div className="relative" data-id="element-87">
          <div className="aspect-video w-full rounded-2xl overflow-hidden shadow-[0_20px_60px_rgba(15,23,42,0.7)] bg-slate-900/60 border border-slate-700/60" data-id="element-88">
            <iframe className="w-full h-full" src="https://www.youtube.com/embed/lzSbw_nu1hg" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen data-id="element-89"></iframe>
          </div>

          {/* Glow effect */}
          <div className="pointer-events-none absolute -inset-8 bg-gradient-to-tr from-sky-500/30 via-indigo-500/20 to-cyan-400/25 blur-3xl opacity-70" data-id="element-90" />
        </div>
      </div>
    </section>;
}
export { HeroSection };